// extracted by mini-css-extract-plugin
export var root = "kvOWXg58n4S0HACjdi8H";